import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { IGetState, TBoardId } from '../../../../../../../../../types/types';
import { toggleBoardStarred } from '../effects/toggleBoardStarred';
import { moveBoardIconToStarred } from '../../../../../../../helpers/moveBoardIconToStarred';

export const onClick = (
    boardId: TBoardId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(toggleBoardStarred(boardId));
        dispatch(moveBoardIconToStarred(boardId));
    };
    return action;
};
